// Blume-styled confirm dialog — promise-based, replaces native confirm()

interface BlumeConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  danger?: boolean
}

export function blumeConfirm(options: BlumeConfirmOptions): Promise<boolean> {
  const {
    title = 'Confirm',
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    danger = false,
  } = options

  return new Promise<boolean>((resolve) => {
    const overlay = document.createElement('div')
    // `bz bz-d2` scopes the Flow design tokens so the card + button primitives
    // resolve their var(--…) values even on pages whose <body> isn't bz-scoped.
    // The dark backdrop is set inline so it wins over the `.bz` ground colour.
    overlay.className = 'bz bz-d2'
    overlay.style.cssText =
      'position:fixed;inset:0;background:rgba(20,18,16,0.45);display:flex;align-items:center;justify-content:center;z-index:9999;padding:1rem;'

    const confirmClass = danger ? 'bz-btn-danger' : 'bz-btn-primary'
    overlay.innerHTML = `
      <div class="bz-card" style="width:100%;max-width:440px;padding:26px 26px 22px;box-shadow:0 24px 60px rgba(20,18,16,0.22);">
        <h3 class="bz-title" style="font-size:18px;margin:0 0 9px;">${title}</h3>
        <p style="color:var(--mute);font-size:14px;line-height:1.55;margin:0 0 24px;">${message}</p>
        <div style="display:flex;justify-content:flex-end;gap:10px;">
          <button id="blume-cancel" class="bz-btn bz-btn-ghost">${cancelText}</button>
          <button id="blume-confirm" class="bz-btn ${confirmClass}">${confirmText}</button>
        </div>
      </div>
    `

    document.body.appendChild(overlay)

    const cleanup = (result: boolean): void => {
      document.body.removeChild(overlay)
      resolve(result)
    }

    const confirmBtn = overlay.querySelector<HTMLButtonElement>('#blume-confirm')
    const cancelBtn = overlay.querySelector<HTMLButtonElement>('#blume-cancel')
    confirmBtn?.addEventListener('click', () => cleanup(true))
    cancelBtn?.addEventListener('click', () => cleanup(false))
    overlay.addEventListener('click', (e) => { if (e.target === overlay) cleanup(false) })
  })
}

// Expose globally for use from non-module scripts (ERB partials, etc.)
;(window as unknown as Record<string, unknown>).blumeConfirm = blumeConfirm
